// extracted by css-extract-rspack-plugin
export default {"stateLabel":"HeaderState-module__stateLabel__Ndz8inD","duplicateIssueLink":"HeaderState-module__duplicateIssueLink__S2gs4_X"};